import { getAuth } from "firebase/auth";
import { useAuthStore } from "../stores/useAuthStore";

export const hasItem = <T>(id: number, array: Array<T>) => {
  return array.some((i) => i?.movieId === id);
};

export const getUserId = (): undefined | string => {
  const user = getAuth()?.currentUser;
  if (user?.providerData?.[0]?.uid) return user.providerData?.[0]?.uid;

  const { profile } = (useAuthStore.getState() as any) ?? {};
  if (profile?.providerData?.[0]?.uid) return profile.providerData?.[0]?.uid;

  return;
};
